import * as React from 'react'
import './styles/ReactSwitch.css'

export default class ReactSwitch extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            toggle: false,
        }
        this.toggleState = this.toggleState.bind(this)
    }

    toggleState() {
        this.setState({
            toggle: !this.state.toggle,
        })

        if (this.props.changeMethod) {
            this.props.changeMethod(!this.state.toggle)
        }
    }

    render() {
        return (
            <div className="switch-field">
                <input
                    type="radio"
                    id="switch_left"
                    name="switchToggle"
                    value={0}
                    onChange={this.toggleState}
                    checked={!this.state.toggle}
                />
                <label htmlFor="switch_left">Percentage</label>

                <input
                    type="radio"
                    id="switch_right"
                    name="switchToggle"
                    value={1}
                    onChange={this.toggleState}
                    checked={this.state.toggle}
                />
                <label htmlFor="switch_right">Value</label>
                <div className="switch_toggle">
                    <div className="switch_btn" />
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/ReactSwitch/ReactSwitch.tsx